import { Dropdown, Menu } from "antd";
import React, { useState } from "react";
import arrow from "../../../assets/svgs/header-icon/arrow-down.svg";
import arrowGrey from "../../../assets/svgs/header-icon/arrow-down-grey.svg";
import { API_Providers } from "../FilterItems/FilterItems";
import SpMenu from "../../SpMenu/SpMenu";
const Api_Providers = ({onChange}) => {
  const [provider, setProvider] = useState("Search provider");
  const [selected, setSelected] = useState(false);

  function handleFilterSelect({item, index}) {
    setProvider(item?.provider?? 'All');

    setSelected(true);

    if (typeof onChange === "function") {
      onChange(item?.provider?? '');
    }
  }

  const menu = (
    <SpMenu items={API_Providers} renderItem={(item) => <p>{item.provider}</p>} onSelect={handleFilterSelect} />
  );


  return (
    <div className="filter-modal-inner">
      <p>API Provider</p>
      <Dropdown overlay={menu} trigger={["click"]} placement="top">
        <button
          className={
            selected ? "selected filter-modal-btn" : "filter-modal-btn"
          }
        >
          {" "}
          {provider}
          <span className="filter-icon">
            {selected ? (
              <img src={arrow} alt="/" />
            ) : (
              <img src={arrowGrey} alt="/" />
            )}
          </span>{" "}
        </button>
      </Dropdown>
    </div>
  );
};

export default Api_Providers;
